// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root____DUP","list":"PatternAutocomplete_list__1rEJn"};